import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthCallback } from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import Browse from "@/pages/Browse";
import ListingDetail from "@/pages/ListingDetail";
import CreateListing from "@/pages/CreateListing";
import Profile from "@/pages/Profile";
import Pricing from "@/pages/Pricing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Admin from "@/pages/Admin";
import Messages from "@/pages/Messages";
import GuidePage from "@/pages/GuidePage";
import PaymentResult from "@/pages/PaymentResult";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ChatWidget } from "@/components/ChatWidget";
import { PromoBanner } from "@/components/PromoBanner";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
    <PromoBanner />
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/browse" element={<Browse />} />
      <Route path="/listing/:id" element={<ListingDetail />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/guide" element={<GuidePage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/create" element={<ProtectedRoute><CreateListing /></ProtectedRoute>} />
      <Route path="/edit/:id" element={<ProtectedRoute><CreateListing /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
      <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult />} />
    </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
      <ChatWidget />
    </BrowserRouter>
  );
}

export default App;
